import { render } from "./TheStructureOfTheCashFlowStatementById.vue?vue&type=template&id=8313981c&scoped=true"
import script from "./TheStructureOfTheCashFlowStatementById.vue?vue&type=script&lang=js"
export * from "./TheStructureOfTheCashFlowStatementById.vue?vue&type=script&lang=js"

import "./TheStructureOfTheCashFlowStatementById.vue?vue&type=style&index=0&id=8313981c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8313981c"]])

export default __exports__